/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verifying_Your_Purchase_CredenInputs */

const en_verifying_your_purchase_creden = /** @type {(inputs: Verifying_Your_Purchase_CredenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifying your purchase credentials...`)
};

const es_verifying_your_purchase_creden = /** @type {(inputs: Verifying_Your_Purchase_CredenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificando tus credenciales de compra...`)
};

const fr_verifying_your_purchase_creden = /** @type {(inputs: Verifying_Your_Purchase_CredenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification de vos identifiants d'achat...`)
};

const de_verifying_your_purchase_creden = /** @type {(inputs: Verifying_Your_Purchase_CredenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Kaufdaten werden verifiziert...`)
};

const ja_verifying_your_purchase_creden = /** @type {(inputs: Verifying_Your_Purchase_CredenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入の認証情報を確認しています...`)
};

const zh_verifying_your_purchase_creden = /** @type {(inputs: Verifying_Your_Purchase_CredenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在验证您的购买凭证...`)
};

const ar_verifying_your_purchase_creden = /** @type {(inputs: Verifying_Your_Purchase_CredenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري التحقق من بيانات الشراء الخاصة بك...`)
};

const id_verifying_your_purchase_creden = /** @type {(inputs: Verifying_Your_Purchase_CredenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memverifikasi kredensial pembelian Anda...`)
};

const it_verifying_your_purchase_creden = /** @type {(inputs: Verifying_Your_Purchase_CredenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica delle credenziali di acquisto in corso...`)
};

const ru_verifying_your_purchase_creden = /** @type {(inputs: Verifying_Your_Purchase_CredenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка данных вашей покупки...`)
};

const pt_verifying_your_purchase_creden = /** @type {(inputs: Verifying_Your_Purchase_CredenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificando suas credenciais de compra...`)
};

const ko_verifying_your_purchase_creden = /** @type {(inputs: Verifying_Your_Purchase_CredenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매 자격을 확인하는 중입니다...`)
};

/**
* | output |
* | --- |
* | "Verifying your purchase credentials..." |
*
* @param {Verifying_Your_Purchase_CredenInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verifying_your_purchase_creden = /** @type {((inputs?: Verifying_Your_Purchase_CredenInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verifying_Your_Purchase_CredenInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verifying_your_purchase_creden(inputs)
	if (locale === "es") return es_verifying_your_purchase_creden(inputs)
	if (locale === "fr") return fr_verifying_your_purchase_creden(inputs)
	if (locale === "de") return de_verifying_your_purchase_creden(inputs)
	if (locale === "ja") return ja_verifying_your_purchase_creden(inputs)
	if (locale === "zh") return zh_verifying_your_purchase_creden(inputs)
	if (locale === "ar") return ar_verifying_your_purchase_creden(inputs)
	if (locale === "id") return id_verifying_your_purchase_creden(inputs)
	if (locale === "it") return it_verifying_your_purchase_creden(inputs)
	if (locale === "ru") return ru_verifying_your_purchase_creden(inputs)
	if (locale === "pt") return pt_verifying_your_purchase_creden(inputs)
	return ko_verifying_your_purchase_creden(inputs)
});